module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M11.818 10.146h8.364a1.671 1.671 0 1 1 0 3.344h-8.364a1.671 1.671 0 1 1 0-3.344zm0 6.692h3.346a1.671 1.671 0 1 1 0 3.344h-3.346a1.673 1.673 0 0 1 0-3.344z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/rawingredients-highlight.js
// module id = 1362
// module chunks = 14